import React, { useState } from "react";
import { P_Props } from "./FocusedMarketForm.type";
import { Form, Field } from "react-final-form";
import { FormUtil, FormUIUtil, loadCallback, ImageUtil } from "../../../../../utils";
import { HtmlEditor, ImageUpload, Loading, SimpleModalHeader, CategoryCard1 } from "../../../../components";
import {
  Grid,
  TextField,
  InputAdornment,
  Switch,
  FormControlLabel,
  Dialog,
  Checkbox
} from "@material-ui/core";
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import {
  Event as EventIcon,
  CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon,
  CheckBox as CheckBoxIcon,
  InfoOutlined as InfoOutlinedIcon
} from "@material-ui/icons";
import { FORM_MODE, FocusedMarketOutputModel } from "../../../../../models";
import { FocusedMarketService } from "../../../../../services";


const FocusedMarketFormPresenter: React.FC<P_Props> = (props) => {
  let submit: any;
  const [visibleTextEditor, setVisibleTextEditor] = useState<boolean>(false);

  const bindingFocusedMarketDataToForm = (data: FocusedMarketOutputModel[]) => {
    const transfomedData = data.reduce((result, item) => {
      return {
        ...result,
        ...item,
        [`title${item.languageId}`]: item.title,
        [`description${item.languageId}`]: item.description,
        [`shortDescription${item.languageId}`]: item.shortDescription
      }
    }, {})
    return transfomedData;
  };

  return (
    <>
      <div className="focusedMarket-form">
        <SimpleModalHeader
          title={props.mode === FORM_MODE.CREATE ? "New Focused Market" : "Edit Focused Market"}
          onClose={() => {
            props.onCancel();
          }}
        />
        <div className="focusedMarket-form__divide">
          <div className="focusedMarket-form__language">
            <h1>Language</h1>
            {props.languageData.map((lang) => {
              return (
                <CategoryCard1
                  key={lang.id}
                  name={lang.name}
                  picture={lang.image || undefined}
                  buildPictureSrc={ImageUtil.buildLanguageImgSrc}
                  onClick={() => {
                    props.onChangeLanguage(lang.id)
                  }}
                  selected={props.activeLanguageId === lang.id}
                  isAvatar={true}
                />
              );
            })}
          </div>

          <div className="focusedMarket-form__box">
            {props.loading && <Loading />}
            {!props.loading && (
              <Form
                initialValues={
                  props.initData?.length
                    ? bindingFocusedMarketDataToForm(props.initData)
                    : {}
                }
                initialValuesEqual={() => true}
                onSubmit={async (values, form) => {
                  props.onSubmit(values);
                }}
                render={({ handleSubmit, form, pristine }) => {
                  submit = handleSubmit;

                  return (
                    <form onSubmit={handleSubmit}>
                      {props.languageData.map((lang) => {
                        return (
                          <div key={lang.id} style={{ display: props.activeLanguageId === lang.id ? "flex" : "none" }}>
                            <Field
                              name={`title${lang.id}`}
                              validate={lang.isPrimary
                                ? FormUtil.Rule.required(
                                  "Xin nhập tiêu đề bài viết"
                                )
                                : undefined}
                              subscription={{ touched: true, error: true, value: true }}
                            >
                              {({ input, meta, ...rest }) => {
                                return FormUIUtil.renderFormItem(
                                  "Title",
                                  <TextField
                                    {...input}
                                    {...rest}
                                    fullWidth
                                    placeholder="Add title"
                                    className="form-text-field"
                                    inputProps={{ className: "input" }}
                                    variant="outlined"
                                    onChange={(e) => input.onChange(e.target.value)}
                                    helperText={meta.touched ? meta.error : ""}
                                    error={meta.error && meta.touched}
                                  />
                                );
                              }}
                            </Field>
                          </div>
                        )
                      })}

                      <Grid item xs={12}>
                        {FormUIUtil.renderFormItem(
                          "Featured Image",
                          <>
                            <ImageUpload
                              className="focusedMarket-form__avatar"
                              fileList={props.focusedMarketPictures}
                              max={1}
                              onChange={props.onUploadBanner}
                              onDelete={props.onRemoveBanner}
                              config={{ uploadModal: true }}
                            />
                            <p className="focusedMarket-form__avatar--note">The image size should be smaller than 500KB</p>
                          </>
                        )}
                      </Grid>

                      <Grid container spacing={6} justify="space-between">
                        <Grid item xs={12} md={6}>
                          {FormUIUtil.renderFormItem(
                            "Status",
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={props.focusedMarketStatus.status}
                                  onChange={(e) => {
                                    props.onChangeFocusedMarketStatus(e.target.checked);
                                  }}
                                  className="app-switch-box"
                                />
                              }
                              label={
                                <div className="form-label" style={{ marginBottom: 0 }}>
                                  Publish
                                </div>
                              }
                            />
                          )}
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <div className="focusedMarket-form__right__publish">
                            <div className="focusedMarket-form__right__publish__allow">
                              <Checkbox
                                className="app-check-box"
                                checked={props.focusedMarketStatus.timePublication !== null}
                                onChange={(e) => {
                                  const isChecked = e.target.checked;
                                  props.onChangeShowPublishTime(isChecked);

                                  if (isChecked) {
                                    props.onChangeTimePublication(new Date().toISOString());
                                  } else {
                                    props.onChangeTimePublication(null);
                                  }
                                }}
                                icon={<CheckBoxOutlineBlankIcon style={{ fontSize: "2.2rem" }} />}
                                checkedIcon={<CheckBoxIcon style={{ fontSize: "2.2rem" }} />}
                              />
                              <div className="form-label" style={{ margin: "0 1rem" }}>
                                Publish Date <InfoOutlinedIcon style={{ marginLeft: "0.5rem" }} />
                              </div>
                            </div>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <DateTimePicker
                                ampm={false}
                                inputVariant="outlined"
                                value={props.focusedMarketStatus.timePublication}
                                onChange={(value) => {
                                  if (value) {
                                    props.onChangeTimePublication(value.toISOString());
                                  }
                                }}
                                format="dd/MM/yyyy hh:mm a"
                                className="form-text-field"
                                fullWidth
                                inputProps={{ className: "input" }}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <EventIcon style={{ fontSize: "2.2rem" }} />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </MuiPickersUtilsProvider>
                          </div>
                        </Grid>
                      </Grid>
                      <Grid item xs={12}>
                        {props.languageData.map((lang) => {
                          return (
                            <div
                              key={lang.id}
                              style={{
                                display: props.activeLanguageId === lang.id ? "flex" : "none",
                              }}
                            >
                              <Field
                                name={`shortDescription${lang.id}`}
                                validate={
                                  lang.isPrimary ? FormUtil.Rule.required("Please input description") : undefined
                                }
                              >
                                {({ input, meta, ...rest }) => {
                                  return FormUIUtil.renderFormItem(
                                    `Description`,
                                    <TextField
                                      {...input}
                                      {...rest}
                                      fullWidth
                                      placeholder="Input description"
                                      className="form-textarea-field"
                                      inputProps={{ className: "input", maxLength: 100 }}
                                      variant="outlined"
                                      onChange={(e) => input.onChange(e.target.value)}
                                      helperText={meta.touched ? meta.error : ""}
                                      error={meta.error && meta.touched}
                                    />
                                  );
                                }}
                              </Field>
                            </div>
                          );
                        })}
                      </Grid>

                      <div
                        onClick={() => {
                          setVisibleTextEditor(true);
                        }}
                        style={{ color: "#6658F3", cursor: "pointer" }}
                        className="form-label"
                      >
                        Write focused market content
                      </div>

                    </form>
                  );
                }}
              />
            )}
          </div>
        </div>
        <div className="focusedMarket-form__footer">
          <button
            className="btn cancel"
            onClick={(e) => {
              e.preventDefault();
              props.onCancel();
            }}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn save"
            onClick={(e) => {
              loadCallback(submit, e);
            }}
          >
            Save
          </button>
        </div>
      </div>

      {props.languageData.map((lang) => {
        if (props.activeLanguageId !== lang.id) {
          return (<div key={lang.id}></div>)
        }

        return (
          <Dialog
            key={lang.id}
            maxWidth="lg"
            fullWidth
            open={visibleTextEditor}
            onClose={() => {
              setVisibleTextEditor(false);
            }}
          >
            <HtmlEditor
              initValue={props.focusedMarketContent[lang.id]}
              imageHandler={props.onUploadContentImgHandler}
              onSave={(val) => {
                setVisibleTextEditor(false);
                if (props.focusedMarketContent[lang.id] !== val) {
                  props.onChangeFocusedMarketContent(val, lang.id);
                }
              }}
              onCancel={() => setVisibleTextEditor(false)}
              onUploadImg={FocusedMarketService.uploadImageFocusedMarketPage} // Thiếu api
              buildImgSrc={ImageUtil.buildFocusedMarketImgSrc}
            />
          </Dialog>
        )
      })
      }
    </>
  );
};

export default FocusedMarketFormPresenter;
